export function swapRowsInData(data, targetRow, draggedRowDetails) {
  for (let i = 0; i < data.length; i++) {
    const row = data[i];
    if (row.id === targetRow.parentId && Array.isArray(row.subRows)) {
      const subRows = row.subRows;
      const targetRowIndex = subRows.findIndex(
        (subRow) => subRow.id === targetRow.id
      );
      const draggedRowIndex = subRows.findIndex(
        (subRow) => subRow.id === draggedRowDetails.id
      );

      if (targetRowIndex !== -1 && draggedRowIndex !== -1) {
        // Swap rows in the subRows array
        const temp = subRows[targetRowIndex];
        subRows[targetRowIndex] = subRows[draggedRowIndex];
        subRows[draggedRowIndex] = temp;
        break;
      }
    }
  }
  return data;
}

export function swapRootRowsInData(data, targetRow, draggedRowDetails) {
  const targetIndex = data.findIndex(
    (row) => row.id === targetRow.id && targetRow.depth === 0
  );
  const draggedIndex = data.findIndex(
    (row) => row.id === draggedRowDetails.id && draggedRowDetails.depth === 0
  );

  if (targetIndex !== -1 && draggedIndex !== -1) {
    // Swap root-level rows
    [data[targetIndex], data[draggedIndex]] = [
      data[draggedIndex],
      data[targetIndex],
    ];
  }

  return data;
}
